import { View } from "binder"
import { DebitCardSelectorViewModel } from "src/arap/rawData/debitCard/debitCardSelector-viewModel";
import { DebitGatewayViewModel } from "./debitGateway-viewModel"

export class DebitGatewayView extends View<DebitGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-BE9C4693-727B-4521-A61E-A51C1F31C386"
    }
    loadHtml(): string {
        let element = require('./debitGateway.html').default;
        let style = require('./debitGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set destinationCardNumber(v: string) { this._destinationCardNumber = v; } public get destinationCardNumber(): string { return this._destinationCardNumber;} private _destinationCardNumber: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set debitCardSelector(v: DebitCardSelectorViewModel) { this._debitCardSelector = v; } public get debitCardSelector(): DebitCardSelectorViewModel { return this._debitCardSelector;} private _debitCardSelector: DebitCardSelectorViewModel;
}
